var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6828_96523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5H11.25V24H3.75C2.79 24 2 23.21 2 22.25V14.5Z",
    fill: "#A2ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.5V22.25C22 23.21 21.21 24 20.25 24H12.75V14.5H22Z",
    fill: "#A2ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.75V11.25C0 12.21 0.79 13 1.75 13H2H11.25V11.5V7H1.75C0.79 7 0 7.79 0 8.75Z",
    fill: "#A2ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 7H12.75V11.5V13H22H22.25C23.21 13 24 12.21 24 11.25V8.75C24 7.79 23.21 7 22.25 7Z",
    fill: "#A2ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 8.044C11.7817 8.044 11.5737 7.949 11.4327 7.784C11.2897 7.619 11.2267 7.4 11.2577 7.184C11.6277 4.684 13.5807 -0.0449982 18.3287 -0.0449982C21.0387 -0.0439982 21.9997 1.42 21.9997 2.674C21.9997 4.903 18.8967 8.044 11.9997 8.044ZM18.3287 1.456C14.7467 1.456 13.3867 4.861 12.9357 6.522C15.7617 6.39 17.5437 5.675 18.5697 5.066C19.9927 4.221 20.4997 3.276 20.4997 2.673C20.4997 1.775 19.3787 1.456 18.3287 1.456Z",
    fill: "#A2ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.04401C5.103 8.04401 2 4.90301 2 2.67401C2 1.42001 2.962 -0.0439911 5.672 -0.0439911C10.419 -0.0439911 12.372 4.68501 12.742 7.18501C12.773 7.40101 12.71 7.62001 12.567 7.78501C12.426 7.94901 12.218 8.04401 12 8.04401ZM5.672 1.45601C4.622 1.45601 3.5 1.77601 3.5 2.67401C3.5 3.95101 5.733 6.27801 11.063 6.52301C10.613 4.86101 9.253 1.45601 5.672 1.45601Z",
    fill: "#A2ADB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6828_96523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardGift);
export default __webpack_public_path__ + "static/media/reward-gift.1331618887cc61e0a993d849fdd02acc.svg";
export { ForwardRef as ReactComponent };